<template>
  <div class="row">
    <label class="col-12 form-control-label">График работы</label>
    <small class="col-12 text-muted">Укажите дни и время работы техцентра</small>
    <hr>
    <div class="col-12">
      <div class="d-flex justify-content-between">
        <div
          class="select-day"
          v-for="day in workDates"
          :key="day.id">
          <div
            :class="{'select-day__item--active': day.selected}"
            class="select-day__item"
            @click="day.selected = !day.selected">
            {{ day.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-2">
      <div class="row">
        <div class="input-group col-5">
          <select
            class="form-control"
            v-model="timeStart"
            :class="{'disabled': allDay}"
            :disabled="allDay">
            <option
              v-for="item in workTimes"
              :value="item.id">
              {{ item.name }}
            </option>
          </select>
          <select
            class="form-control"
            v-model="timeEnd"
            :class="{'disabled': allDay}"
            :disabled="allDay">
            <option
              v-for="item in workTimes"
              :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="form-check col-3">
          <input
            type="checkbox"
            class="form-check-input"
            id="infinityCheck"
            v-model="allDay">
          <label class="form-check-label" for="infinityCheck">Круглосуточно</label>
        </div>
        <div class="col-4">
          <button
            type="button"
            class="btn btn-primary"
            :class="{'disabled': buttonDisabled}"
            :disabled="buttonDisabled"
            @click="addSchedule">
              Добавить
          </button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <span
        class="small text-danger"
        v-if="error">
          {{error}}
      </span>
    </div>
    <div class="col-12 mt-2">
      <div
        class="alert alert-info"
        v-for="item in schedule"
        :key="item.id">
        {{ item | parseSchedule }}
        <button
          type="button"
          class="close"
          @click.prevent="deleteSchedule(item.id)">
          <span aria-hidden="true" class="text-primary">&times;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { workDates, getDayName } from './../../../helpers/workDates'
import workTimes from './../../../helpers/workTimes'

export default {
  name: 'TcSelectWorkTime',
  props: {
    /**
     * value = Array(
     *  Object(
     *      id: Number,
     *      dayIds: Array (String),
     *      timeStart: String
     *      timeEnd: String
     *    )
     * )
     */
    value: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    parseSchedule (value) {
      let parsedText = ''
      let checkDay = false
      if (value.dayIds.length > 1) {
        for (let i = 0; i < value.dayIds.length; i++) {
          if (value.dayIds[i + 1] && value.dayIds[i] + 1 !== value.dayIds[i + 1]) {
            checkDay = true
            break
          }
        }
        if (checkDay) {
          for (let i = 0; i < value.dayIds.length; i++) {
            parsedText += getDayName(value.dayIds[i]) + ', '
          }
        } else {
          parsedText += getDayName(value.dayIds[0], true) + ' - ' +
            getDayName(value.dayIds[value.dayIds.length - 1], true) + ', '
        }
      } else {
        parsedText += getDayName(value.dayIds[0], true) + ' '
      }
      if (value.timeStart === '00:00:00' && value.timeEnd === '00:00:00') {
        parsedText += 'круглосуточно'
      } else {
        parsedText += 'c ' + value.timeStart.slice(0, 5) + ' до ' + value.timeEnd.slice(0, 5)
      }
      return parsedText
    }
  },
  computed: {
    buttonDisabled: function () {
      let countDays = 0
      for (let i = 0; i < this.workDates.length; i++) {
        if (this.workDates[i].selected === true) {
          countDays++
        }
      }
      return countDays === 0
    }
  },
  data () {
    return {
      workDates: workDates(),
      workTimes: workTimes(),
      schedule: this.value,
      timeStart: '08:00:00',
      timeEnd: '22:00:00',
      allDay: false,
      error: ''
    }
  },
  methods: {
    deleteSchedule (id) {
      this.schedule = this.schedule.filter((el) => {
        return el.id !== id
      })
      this.$emit('input', this.schedule)
    },
    addSchedule () {
      this.error = ''
      if (this.timeStart > this.timeEnd) {
        this.error = 'Время начала рабочего дня должно быть меньше окончания рабочего дня'
        return false
      }
      if (this.allDay) {
        this.timeStart = '00:00:00'
        this.timeEnd = '00:00:00'
      }
      let newSchedule = {
        id: this.getNewId(),
        dayIds: [],
        timeStart: this.timeStart,
        timeEnd: this.timeEnd
      }
      for (let i = 0; i < this.workDates.length; i++) {
        if (this.workDates[i].selected === true) {
          newSchedule.dayIds.push(this.workDates[i].id)
          this.workDates[i].selected = false
        }
      }
      this.schedule.push(newSchedule)
      this.timeStart = '08:00:00'
      this.timeEnd = '22:00:00'
      this.$emit('input', this.schedule)
    },
    getNewId () {
      if (this.schedule.length > 0) {
        return this.schedule[this.schedule.length - 1].id + 1
      } else {
        return 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
.select-day {
  &__item {
    color: #1b6aaa;
    margin-right: 0.8rem;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 5px;
    transition: 0.3s;

    &:hover {
      color: #fcfaff;
      background: #2199ed;
    }

    &--active {
      color: white;
      background: #1b6aaa;

      &:hover {
        color: white;
        background: #1b6aaa;
      }
    }
  }
}
hr {
  width: 100%;
  margin-right: 15px;
  margin-left: 15px;
  margin-top: 4px;
}
.form-check {
  padding-top: 8px;

  &-input {
    margin-left: 0;
  }
}
select.disabled {
  background: rgba(128, 128, 128, 0.08)!important;
}
</style>



// WEBPACK FOOTER //
// TcSelectWorkTime.vue?16123318